import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import "./styles/element/index.scss";
import "./styles/global.less";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
// import dayjs from "dayjs";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import permissionDirective from "@/directives/permission";
import filters from "@/utils/filters";
import { useConfigStore } from "@/store/configStore";
import PageContainer from "@/components/PageContainer.vue";
// createApp(App).use(router).mount("#app");
const app = createApp(App);
const pinia = createPinia();
// 注册ElementPlus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
// 注册PageContainer组件
app.component("PageContainer", PageContainer);
// 注册全局过滤器
app.config.globalProperties.$filters = filters;
app.use(pinia);
// 使用持久化插件
pinia.use(piniaPluginPersistedstate);
const loadConfig = async () => {
  try {
    const response = await fetch("/config.json");
    const data = await response.json();
    const configStore = useConfigStore();
    configStore.setConfig(data);
  } catch (error) {
    console.error("Failed to load config:", error);
  }
};
app.use(router);
app.directive("permission", permissionDirective);
app.use(ElementPlus, {
  locale: zhCn, // 设置全局语言为中文
});
loadConfig().then(() => {
  app.mount("#app");
});
